import type { ReactNode } from "react"
import { createPortal } from "react-dom"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

type StyleProps = Readonly<{
    topRem: number
    leftRem: number
}>

const useStyles = makeStyles<StyleProps>()((_theme, { topRem, leftRem }) => ({
    tooltipPortal: {
        position: "absolute",
        top: `${topRem}rem`,
        left: `${leftRem}rem`,
        transform: "translate(-50%, -100%)",
        zIndex: 1300,
        pointerEvents: "none",
    },
}))

type CalendarTooltipPortalProps = Readonly<{
    topPx: number
    leftPx: number
    children: ReactNode
}>

export function CalendarTooltipPortal({ topPx, leftPx, children }: CalendarTooltipPortalProps) {
    const { classes } = useStyles({
        topRem: topPx / 16,
        leftRem: leftPx / 16,
    })

    if (typeof document === "undefined") return null
    if (!document.body) return null

    return createPortal(<Box className={classes.tooltipPortal}>{children}</Box>, document.body)
}
